type CountryName =
    'USA' | 'Antigua And Barbuda' | 'Afghanistan' | 'Aland Islands' |
    'Albania' | 'Algeria' | 'Andorra' | 'Angola' | 'Anguilla' | 'Antigua' |
    'Argentina' | 'Armenia' | 'Aruba' | 'Austria' | 'Antarctica' | 'French Southern Terr' |
    'Australia' | 'Azerbaidjan' | 'Bahrain' | 'Bangladesh' | 'Barbados' | 'Belarus' |
    'Benin' | 'Bermuda' | 'Burkina Faso' | 'Bahamas' | 'Bhutan' | 'Belgium' | 'Belize' |
    'Bolivia' | 'Bosnia-herzegovina' | 'Botswana' | 'Bouvet Islands' | 'Brazil' | 'Burundi' |
    'Brunei Darussalam' | 'Bulgaria' | 'Virgin Islands (brit' | 'Cameroon' | 'Canada' |
    'Central African Repu' | 'Cayman Islands' | 'Cocos (Keeling) Isd' | 'Chad' | 'Chile' |
    'Cook Islands' | 'China' | 'Colombia' | 'Comoros' | 'Congo' | 'Costa Rica' | 'Croatia' |
    'Cuba' | 'Curacao' | 'Cape Verde' | 'Cyprus' | 'Czech Republic' | 'Denmark' | 'Djibouti' |
    'Dominica' | 'Dominican Republic' | 'Ecuador' | 'Equatiorial Guinea' | 'Egypt' |
    'El Salvador' | 'Eritrea' | 'Western Sahara' | 'Estonia' | 'Ethiopia' | 'Falkland Islands' |
    'Faroe Islands' | 'French Guiana' | 'Fiji' | 'Finland' | 'French Polynesia' | 'France' |
    'Gabon' | 'Gambia' | 'Guinea Bissau' | 'Guernsey (Cnl Islnds' | 'Guadeloupe' | 'Georgia' |
    'Germany' | 'Ghana' | 'Gibraltar' | 'Grenada' | 'Greece' | 'Greenland' | 'Guatemala' |
    'Guinea' | 'Guyana' | 'Haiti' | 'Hong Kong' | 'Heard Isl/mcdonald I' | 'Honduras' |
    'Hungary' | 'Iceland' | 'Indonesia' | 'India' | 'British Indian Ocean' | 'Iran' | 'Ireland' |
    'Iraq' | 'Israel' | 'Italy' | 'Cote D\'ivoire' | 'Jamaica' | 'Svalbard & Mayen' | 'Japan' |
    'Jersey Chan\'l Is' | 'Jordan' | 'Kazakhstan' | 'Kenya' | 'Cambodia' | 'Kiribati' |
    'South Korea' | 'Kuwait' | 'Kyrgyzstan' | 'Laos' | 'Latvia' | 'Libya(n Arab Jamahi)' |
    'Lebanon' | 'Lesotho' | 'Liberia' | 'Liechtenstein' | 'Lithuania' | 'Luxembourg' | 'Macao' |
    'Madagascar' | 'Malawi' | 'Mayotte' | 'Martinique' | 'Mauritania' | 'Maldives' | 'Mexico' |
    'Mongolia' | 'Micronesia' | 'Marshall Islands' | 'Mali' | 'Malta' | 'Malaysia' |
    'Macedonia' | 'Montenegro' | 'Moldova' | 'Monaco' | 'Morocco' | 'Montserrat' | 'Mozambique' |
    'Mauritius' | 'Myanmar (Burma)' | 'Namibia' | 'Nauru' | 'New Caledonia' | 'Nepal' |
    'Netherlands' | 'Norfolk Island' | 'Niger' | 'Nicaragua' | 'Nigeria' | 'Niue' | 'Norway' |
    'New Zealand' | 'Oman' | 'Pakistan' | 'Palau' | 'Panama' | 'Paraguay' | 'Peru' |
    'Philippines' | 'Pitcairn Islands' | 'Papua New Guinea' | 'Poland' | 'Portugal' |
    'Sao Tome Princ' | 'Palestinian Territor' | 'Qatar' | 'Reunion Island' | 'Romania' |
    'Russia Federation' | 'Rwanda' | 'South Africa' | 'Samoa' | 'Saudi Arabia' | 'Senegal' |
    'Serbia' | 'Seychelles' | 'S Georgia/s Sandwich' | 'Saint Helena' | 'Sierra Leone' |
    'Singapore' | 'Saint Kitts Nevi' | 'Solomon Islands' | 'Slovakia' | 'Saint Lucia' |
    'Slovenia' | 'San Marino' | 'Somalia' | 'Spain' | 'St Pierre Miquelon' | 'Sri Lanka' |
    'Sudan' | 'Suriname' | 'Saint Vincent Grnd' | 'Sweden' | 'Switzerland' | 'Swaziland' |
    'Sint Maarten' | 'Syrian Arab Republic' | 'Taiwan' | 'Tajikistan' | 'Tanzania' |
    'Turks Caicos' | 'Thailand' | 'Turkmenistan' | 'Timor-leste' | 'Tonga' | 'Togo' |
    'Tokelau' | 'Trinidad And Tobago' | 'Tunisia' | 'Turkey' | 'Tuvalu' |
    'United Arab Emirates' | 'Uganda' | 'United Kingdom' | 'Ukraine' | 'Us Minor Is' |
    'Uruguay' | 'Uzbekistan' | 'Vanuatu' | 'Vatican City State' | 'Venezuela' | 'Vietnam' |
    'Wallis And Futuna' | 'Yemen' | 'Yemen (North)' | 'Yemen (Saden)' | 'Zaire' | 'Zambia' | 'Zimbabwe';

export const countries: CountryName[] = [
    'USA', 'Antigua And Barbuda', 'Afghanistan', 'Aland Islands',
    'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua',
    'Argentina', 'Armenia', 'Aruba', 'Austria', 'Antarctica', 'French Southern Terr',
    'Australia', 'Azerbaidjan', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus',
    'Benin', 'Bermuda', 'Burkina Faso', 'Bahamas', 'Bhutan', 'Belgium', 'Belize',
    'Bolivia', 'Bosnia-herzegovina', 'Botswana', 'Bouvet Islands', 'Brazil', 'Burundi',
    'Brunei Darussalam', 'Bulgaria', 'Virgin Islands (brit', 'Cameroon', 'Canada',
    'Central African Repu', 'Cayman Islands', 'Cocos (Keeling) Isd', 'Chad', 'Chile',
    'Cook Islands', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia',
    'Cuba', 'Curacao', 'Cape Verde', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti',
    'Dominica', 'Dominican Republic', 'Ecuador', 'Equatiorial Guinea', 'Egypt',
    'El Salvador', 'Eritrea', 'Western Sahara', 'Estonia', 'Ethiopia', 'Falkland Islands',
    'Faroe Islands', 'French Guiana', 'Fiji', 'Finland', 'French Polynesia', 'France',
    'Gabon', 'Gambia', 'Guinea Bissau', 'Guernsey (Cnl Islnds', 'Guadeloupe', 'Georgia',
    'Germany', 'Ghana', 'Gibraltar', 'Grenada', 'Greece', 'Greenland', 'Guatemala',
    'Guinea', 'Guyana', 'Haiti', 'Hong Kong', 'Heard Isl/mcdonald I', 'Honduras',
    'Hungary', 'Iceland', 'Indonesia', 'India', 'British Indian Ocean', 'Iran', 'Ireland',
    'Iraq', 'Israel', 'Italy', 'Cote D\'ivoire', 'Jamaica', 'Svalbard & Mayen', 'Japan',
    'Jersey Chan\'l Is', 'Jordan', 'Kazakhstan', 'Kenya', 'Cambodia', 'Kiribati',
    'South Korea', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Libya(n Arab Jamahi)',
    'Lebanon', 'Lesotho', 'Liberia', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao',
    'Madagascar', 'Malawi', 'Mayotte', 'Martinique', 'Mauritania', 'Maldives', 'Mexico',
    'Mongolia', 'Micronesia', 'Marshall Islands', 'Mali', 'Malta', 'Malaysia',
    'Macedonia', 'Montenegro', 'Moldova', 'Monaco', 'Morocco', 'Montserrat', 'Mozambique',
    'Mauritius', 'Myanmar (Burma)', 'Namibia', 'Nauru', 'New Caledonia', 'Nepal',
    'Netherlands', 'Norfolk Island', 'Niger', 'Nicaragua', 'Nigeria', 'Niue', 'Norway',
    'New Zealand', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Paraguay', 'Peru',
    'Philippines', 'Pitcairn Islands', 'Papua New Guinea', 'Poland', 'Portugal',
    'Sao Tome Princ', 'Palestinian Territor', 'Qatar', 'Reunion Island', 'Romania',
    'Russia Federation', 'Rwanda', 'South Africa', 'Samoa', 'Saudi Arabia', 'Senegal',
    'Serbia', 'Seychelles', 'S Georgia/s Sandwich', 'Saint Helena', 'Sierra Leone',
    'Singapore', 'Saint Kitts Nevi', 'Solomon Islands', 'Slovakia', 'Saint Lucia',
    'Slovenia', 'San Marino', 'Somalia', 'Spain', 'St Pierre Miquelon', 'Sri Lanka',
    'Sudan', 'Suriname', 'Saint Vincent Grnd', 'Sweden', 'Switzerland', 'Swaziland',
    'Sint Maarten', 'Syrian Arab Republic', 'Taiwan', 'Tajikistan', 'Tanzania',
    'Turks Caicos', 'Thailand', 'Turkmenistan', 'Timor-leste', 'Tonga', 'Togo',
    'Tokelau', 'Trinidad And Tobago', 'Tunisia', 'Turkey', 'Tuvalu',
    'United Arab Emirates', 'Uganda', 'United Kingdom', 'Ukraine', 'Us Minor Is',
    'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City State', 'Venezuela', 'Vietnam',
    'Wallis And Futuna', 'Yemen', 'Yemen (North)', 'Yemen (Saden)', 'Zaire', 'Zambia', 'Zimbabwe'
]

export interface CountriesDisplayAndAPI {
    value: CountryName;
    key: CountryName;
}

export const countryDisplayNameAndApiName: CountriesDisplayAndAPI[] = [
    {value: 'USA', key: 'USA'},
    {value: 'Antigua And Barbuda', key: 'Antigua And Barbuda'},
    {value: 'Afghanistan', key: 'Afghanistan'},
    {value: 'Aland Islands', key: 'Aland Islands'},
    {value: 'Albania', key: 'Albania'},
    {value: 'Algeria', key: 'Algeria'},
    {value: 'Andorra', key: 'Andorra'},
    {value: 'Angola', key: 'Angola'},
    {value: 'Anguilla', key: 'Anguilla'},
    {value: 'Antigua', key: 'Antigua'},
    {value: 'Argentina', key: 'Argentina'},
    {value: 'Armenia', key: 'Armenia'},
    {value: 'Aruba', key: 'Aruba'},
    {value: 'Austria', key: 'Austria'},
    {value: 'Antarctica', key: 'Antarctica'},
    {value: 'French Southern Terr', key: 'French Southern Terr'},
    {value: 'Australia', key: 'Australia'},
    {value: 'Azerbaidjan', key: 'Azerbaidjan'},
    {value: 'Bahrain', key: 'Bahrain'},
    {value: 'Bangladesh', key: 'Bangladesh'},
    {value: 'Barbados', key: 'Barbados'},
    {value: 'Belarus', key: 'Belarus'},
    {value: 'Benin', key: 'Benin'},
    {value: 'Bermuda', key: 'Bermuda'},
    {value: 'Burkina Faso', key: 'Burkina Faso'},
    {value: 'Bahamas', key: 'Bahamas'},
    {value: 'Bhutan', key: 'Bhutan'},
    {value: 'Belgium', key: 'Belgium'},
    {value: 'Belize', key: 'Belize'},
    {value: 'Bolivia', key: 'Bolivia'},
    {value: 'Bosnia-herzegovina', key: 'Bosnia-herzegovina'},
    {value: 'Botswana', key: 'Botswana'},
    {value: 'Bouvet Islands', key: 'Bouvet Islands'},
    {value: 'Brazil', key: 'Brazil'},
    {value: 'Burundi', key: 'Burundi'},
    {value: 'Brunei Darussalam', key: 'Brunei Darussalam'},
    {value: 'Bulgaria', key: 'Bulgaria'},
    {value: 'Virgin Islands (brit', key: 'Virgin Islands (brit'},
    {value: 'Cameroon', key: 'Cameroon'},
    {value: 'Canada', key: 'Canada'},
    {value: 'Central African Repu', key: 'Central African Repu'},
    {value: 'Cayman Islands', key: 'Cayman Islands'},
    {value: 'Cocos (Keeling) Isd', key: 'Cocos (Keeling) Isd'},
    {value: 'Chad', key: 'Chad'},
    {value: 'Chile', key: 'Chile'},
    {value: 'Cook Islands', key: 'Cook Islands'},
    {value: 'China', key: 'China'},
    {value: 'Colombia', key: 'Colombia'},
    {value: 'Comoros', key: 'Comoros'},
    {value: 'Congo', key: 'Congo'},
    {value: 'Costa Rica', key: 'Costa Rica'},
    {value: 'Croatia', key: 'Croatia'},
    {value: 'Cuba', key: 'Cuba'},
    {value: 'Curacao', key: 'Curacao'},
    {value: 'Cape Verde', key: 'Cape Verde'},
    {value: 'Cyprus', key: 'Cyprus'},
    {value: 'Czech Republic', key: 'Czech Republic'},
    {value: 'Denmark', key: 'Denmark'},
    {value: 'Djibouti', key: 'Djibouti'},
    {value: 'Dominica', key: 'Dominica'},
    {value: 'Dominican Republic', key: 'Dominican Republic'},
    {value: 'Ecuador', key: 'Ecuador'},
    {value: 'Equatiorial Guinea', key: 'Equatiorial Guinea'},
    {value: 'Egypt', key: 'Egypt'},
    {value: 'El Salvador', key: 'El Salvador'},
    {value: 'Eritrea', key: 'Eritrea'},
    {value: 'Western Sahara', key: 'Western Sahara'},
    {value: 'Estonia', key: 'Estonia'},
    {value: 'Ethiopia', key: 'Ethiopia'},
    {value: 'Falkland Islands', key: 'Falkland Islands'},
    {value: 'Faroe Islands', key: 'Faroe Islands'},
    {value: 'French Guiana', key: 'French Guiana'},
    {value: 'Fiji', key: 'Fiji'},
    {value: 'Finland', key: 'Finland'},
    {value: 'French Polynesia', key: 'French Polynesia'},
    {value: 'France', key: 'France'},
    {value: 'Gabon', key: 'Gabon'},
    {value: 'Gambia', key: 'Gambia'},
    {value: 'Guinea Bissau', key: 'Guinea Bissau'},
    {value: 'Guernsey (Cnl Islnds', key: 'Guernsey (Cnl Islnds'},
    {value: 'Guadeloupe', key: 'Guadeloupe'},
    {value: 'Georgia', key: 'Georgia'},
    {value: 'Germany', key: 'Germany'},
    {value: 'Ghana', key: 'Ghana'},
    {value: 'Gibraltar', key: 'Gibraltar'},
    {value: 'Grenada', key: 'Grenada'},
    {value: 'Greece', key: 'Greece'},
    {value: 'Greenland', key: 'Greenland'},
    {value: 'Guatemala', key: 'Guatemala'},
    {value: 'Guinea', key: 'Guinea'},
    {value: 'Guyana', key: 'Guyana'},
    {value: 'Haiti', key: 'Haiti'},
    {value: 'Hong Kong', key: 'Hong Kong'},
    {value: 'Heard Isl/mcdonald I', key: 'Heard Isl/mcdonald I'},
    {value: 'Honduras', key: 'Honduras'},
    {value: 'Hungary', key: 'Hungary'},
    {value: 'Iceland', key: 'Iceland'},
    {value: 'Indonesia', key: 'Indonesia'},
    {value: 'India', key: 'India'},
    {value: 'British Indian Ocean', key: 'British Indian Ocean'},
    {value: 'Iran', key: 'Iran'},
    {value: 'Ireland', key: 'Ireland'},
    {value: 'Iraq', key: 'Iraq'},
    {value: 'Israel', key: 'Israel'},
    {value: 'Italy', key: 'Italy'},
    {value: 'Cote D\'ivoire', key: 'Cote D\'ivoire'},
    {value: 'Jamaica', key: 'Jamaica'},
    {value: 'Svalbard & Mayen', key: 'Svalbard & Mayen'},
    {value: 'Japan', key: 'Japan'},
    {value: 'Jersey Chan\'l Is', key: 'Jersey Chan\'l Is'},
    {value: 'Jordan', key: 'Jordan'},
    {value: 'Kazakhstan', key: 'Kazakhstan'},
    {value: 'Kenya', key: 'Kenya'},
    {value: 'Cambodia', key: 'Cambodia'},
    {value: 'Kiribati', key: 'Kiribati'},
    {value: 'South Korea', key: 'South Korea'},
    {value: 'Kuwait', key: 'Kuwait'},
    {value: 'Kyrgyzstan', key: 'Kyrgyzstan'},
    {value: 'Laos', key: 'Laos'},
    {value: 'Latvia', key: 'Latvia'},
    {value: 'Libya(n Arab Jamahi)', key: 'Libya(n Arab Jamahi)'},
    {value: 'Lebanon', key: 'Lebanon'},
    {value: 'Lesotho', key: 'Lesotho'},
    {value: 'Liberia', key: 'Liberia'},
    {value: 'Liechtenstein', key: 'Liechtenstein'},
    {value: 'Lithuania', key: 'Lithuania'},
    {value: 'Luxembourg', key: 'Luxembourg'},
    {value: 'Macao', key: 'Macao'},
    {value: 'Madagascar', key: 'Madagascar'},
    {value: 'Malawi', key: 'Malawi'},
    {value: 'Mayotte', key: 'Mayotte'},
    {value: 'Martinique', key: 'Martinique'},
    {value: 'Mauritania', key: 'Mauritania'},
    {value: 'Maldives', key: 'Maldives'},
    {value: 'Mexico', key: 'Mexico'},
    {value: 'Mongolia', key: 'Mongolia'},
    {value: 'Micronesia', key: 'Micronesia'},
    {value: 'Marshall Islands', key: 'Marshall Islands'},
    {value: 'Mali', key: 'Mali'},
    {value: 'Malta', key: 'Malta'},
    {value: 'Malaysia', key: 'Malaysia'},
    {value: 'Macedonia', key: 'Macedonia'},
    {value: 'Montenegro', key: 'Montenegro'},
    {value: 'Moldova', key: 'Moldova'},
    {value: 'Monaco', key: 'Monaco'},
    {value: 'Morocco', key: 'Morocco'},
    {value: 'Montserrat', key: 'Montserrat'},
    {value: 'Mozambique', key: 'Mozambique'},
    {value: 'Mauritius', key: 'Mauritius'},
    {value: 'Myanmar (Burma)', key: 'Myanmar (Burma)'},
    {value: 'Namibia', key: 'Namibia'},
    {value: 'Nauru', key: 'Nauru'},
    {value: 'New Caledonia', key: 'New Caledonia'},
    {value: 'Nepal', key: 'Nepal'},
    {value: 'Netherlands', key: 'Netherlands'},
    {value: 'Norfolk Island', key: 'Norfolk Island'},
    {value: 'Niger', key: 'Niger'},
    {value: 'Nicaragua', key: 'Nicaragua'},
    {value: 'Nigeria', key: 'Nigeria'},
    {value: 'Niue', key: 'Niue'},
    {value: 'Norway', key: 'Norway'},
    {value: 'New Zealand', key: 'New Zealand'},
    {value: 'Oman', key: 'Oman'},
    {value: 'Pakistan', key: 'Pakistan'},
    {value: 'Palau', key: 'Palau'},
    {value: 'Panama', key: 'Panama'},
    {value: 'Paraguay', key: 'Paraguay'},
    {value: 'Peru', key: 'Peru'},
    {value: 'Philippines', key: 'Philippines'},
    {value: 'Pitcairn Islands', key: 'Pitcairn Islands'},
    {value: 'Papua New Guinea', key: 'Papua New Guinea'},
    {value: 'Poland', key: 'Poland'},
    {value: 'Portugal', key: 'Portugal'},
    {value: 'Sao Tome Princ', key: 'Sao Tome Princ'},
    {value: 'Palestinian Territor', key: 'Palestinian Territor'},
    {value: 'Qatar', key: 'Qatar'},
    {value: 'Reunion Island', key: 'Reunion Island'},
    {value: 'Romania', key: 'Romania'},
    {value: 'Russia Federation', key: 'Russia Federation'},
    {value: 'Rwanda', key: 'Rwanda'},
    {value: 'South Africa', key: 'South Africa'},
    {value: 'Samoa', key: 'Samoa'},
    {value: 'Saudi Arabia', key: 'Saudi Arabia'},
    {value: 'Senegal', key: 'Senegal'},
    {value: 'Serbia', key: 'Serbia'},
    {value: 'Seychelles', key: 'Seychelles'},
    {value: 'S Georgia/s Sandwich', key: 'S Georgia/s Sandwich'},
    {value: 'Saint Helena', key: 'Saint Helena'},
    {value: 'Sierra Leone', key: 'Sierra Leone'},
    {value: 'Singapore', key: 'Singapore'},
    {value: 'Saint Kitts Nevi', key: 'Saint Kitts Nevi'},
    {value: 'Solomon Islands', key: 'Solomon Islands'},
    {value: 'Slovakia', key: 'Slovakia'},
    {value: 'Saint Lucia', key: 'Saint Lucia'},
    {value: 'Slovenia', key: 'Slovenia'},
    {value: 'San Marino', key: 'San Marino'},
    {value: 'Somalia', key: 'Somalia'},
    {value: 'Spain', key: 'Spain'},
    {value: 'St Pierre Miquelon', key: 'St Pierre Miquelon'},
    {value: 'Sri Lanka', key: 'Sri Lanka'},
    {value: 'Sudan', key: 'Sudan'},
    {value: 'Suriname', key: 'Suriname'},
    {value: 'Saint Vincent Grnd', key: 'Saint Vincent Grnd'},
    {value: 'Sweden', key: 'Sweden'},
    {value: 'Switzerland', key: 'Switzerland'},
    {value: 'Swaziland', key: 'Swaziland'},
    {value: 'Sint Maarten', key: 'Sint Maarten'},
    {value: 'Syrian Arab Republic', key: 'Syrian Arab Republic'},
    {value: 'Taiwan', key: 'Taiwan'},
    {value: 'Tajikistan', key: 'Tajikistan'},
    {value: 'Tanzania', key: 'Tanzania'},
    {value: 'Turks Caicos', key: 'Turks Caicos'},
    {value: 'Thailand', key: 'Thailand'},
    {value: 'Turkmenistan', key: 'Turkmenistan'},
    {value: 'Timor-leste', key: 'Timor-leste'},
    {value: 'Tonga', key: 'Tonga'},
    {value: 'Togo', key: 'Togo'},
    {value: 'Tokelau', key: 'Tokelau'},
    {value: 'Trinidad And Tobago', key: 'Trinidad And Tobago'},
    {value: 'Tunisia', key: 'Tunisia'},
    {value: 'Turkey', key: 'Turkey'},
    {value: 'Tuvalu', key: 'Tuvalu'},
    {value: 'United Arab Emirates', key: 'United Arab Emirates'},
    {value: 'Uganda', key: 'Uganda'},
    {value: 'United Kingdom', key: 'United Kingdom'},
    {value: 'Ukraine', key: 'Ukraine'},
    {value: 'Us Minor Is', key: 'Us Minor Is'},
    {value: 'Uruguay', key: 'Uruguay'},
    {value: 'Uzbekistan', key: 'Uzbekistan'},
    {value: 'Vanuatu', key: 'Vanuatu'},
    {value: 'Vatican City State', key: 'Vatican City State'},
    {value: 'Venezuela', key: 'Venezuela'},
    {value: 'Vietnam', key: 'Vietnam'},
    {value: 'Wallis And Futuna', key: 'Wallis And Futuna'},
    {value: 'Yemen', key: 'Yemen'},
    {value: 'Yemen (North)', key: 'Yemen (North)'},
    {value: 'Yemen (Saden)', key: 'Yemen (Saden)'},
    {value: 'Zaire', key: 'Zaire'},
    {value: 'Zambia', key: 'Zambia'},
    {value: 'Zimbabwe', key: 'Zimbabwe'},
]

// Postal code regexes for specific countries that have their own standard.
const POSTAL_CODE_REGEX_FOR_COUNTRY: Map<CountryName, RegExp> = new Map([
    ['USA', /^[0-9]{5}(?:[\s]*[\-]?[\s]*[0-9]{4})?$/],
    ['Algeria', /^[0-9]{5}$/],
	['Andorra', /^[0-9]{3}$/],
	['Argentina', /^[a-zA-Z0-9]?([0-9]{4})([a-zA-Z0-9]{3})?$/],
    ['Canada', /^[a-zA-Z][0-9]?[a-zA-Z][\s\-]*[0-9]?[a-zA-Z][0-9]?$/]
]);

export function hasPostalCodeRegex(country: CountryName) {
    return POSTAL_CODE_REGEX_FOR_COUNTRY.has(country);
}

export function getPostalCodeRegex(country: CountryName): RegExp | undefined {
    if(hasPostalCodeRegex(country)) {
        return POSTAL_CODE_REGEX_FOR_COUNTRY.get(country);
    }

    if(country === 'Sint Maarten') {
        return undefined;
    }

    return /^[a-zA-Z0-9]{0,9}$/;
}
